<cr-icon class="icon" [name]="icon"></cr-icon> <div *ngIf="message !== undefined" class="message">{{ message }}</div> <ng-content></ng-content> 